// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_87cce84","item":"_a90bb55","image":"_3981c1a","itemHeading":"_33eb671"};